import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWhatsappGreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "uuid-751c26c8-589b-47d1-b190-eae0dbd9daba",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .uuid-9e601852-a480-4456-810f-677576080755 {\n        fill: #4ab749;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "uuid-9e601852-a480-4456-810f-677576080755",
			d: "M70.9,76.25c-10.1,7.16-23.4,7.91-34.22,2.01l-17.22,4.51,4.6-16.82c-7.41-12.86-5.18-29.25,5.65-39.62,5.36-5.19,12.33-8.33,19.85-9,9.7-.68,18.86,2.64,25.71,9.55,6.45,6.51,9.81,15.36,9.34,24.54-.5,9.91-5.58,19.07-13.71,24.83M37.51,72.37c11.5,7.43,26.49,5.06,35.17-5.12,10.86-12.73,7.72-32.04-6.62-40.7-10.83-6.53-24.84-4.55-33.52,4.67-8.68,9.23-9.81,23.32-2.56,33.83l-2.71,9.97,10.25-2.66Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "uuid-9e601852-a480-4456-810f-677576080755",
			d: "M61.29,53.79l6.86,3.29c1.09.52.21,3.93-.45,4.89-1.04,1.51-2.77,2.51-4.52,3.04-2.37.71-4.66.2-6.92-.55-4.08-1.35-7.67-3.32-10.85-6.23-3.05-2.8-5.68-5.93-7.8-9.5-2.52-4.23-2.83-9.27.84-12.9,1.31-1.29,2.36-1.26,4.53-1.01.35.04.82.67.96,1.02l2.64,6.33c.24.58.3,1.16-.09,1.71-.65.91-1.34,1.83-2.05,2.69-.48.58-.41,1.03-.05,1.63,2.57,4.37,6.37,7.7,11.1,9.52.67.26,1.18.25,1.66-.36l2.55-3.17c.38-.47.91-.73,1.6-.4"
		})
	]
});
export default SvgWhatsappGreen;
